import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { BookpageListDialogComponent } from './bookpage-list-dialog/bookpage-list-dialog.component';
import { BookpageListComponent } from './bookpage-list/bookpage-list.component';

@NgModule({
    exports: [BookpageListComponent, BookpageListDialogComponent],
    imports: [
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        BookpageListComponent, BookpageListDialogComponent,
    ],
})
export class PcpSlideSyncBookpageDialogModule {}
